<evc-menu
  data-testid="apps-menu"
  class="menu menu--applications z-above"
  position="bottom-right">
  @let frame = isIms() ? 'full' : 'ghost';
  @let type = isIms() ? 'primary' : 'neutral';
  <evc-button
    trigger
    evcMenuTriggerState
    class="trigger"
    icon="global-menu"
    size="small"
    [frame]="frame"
    [type]="type"
    style="--button-padding: 0.6rem">
  </evc-button>

  <div class="apps-menu">
    <evc-button
      data-testid="apps-menu--home"
      class="apps-menu__home-btn button_full-width"
      icon="home"
      [text]="('menus.applications.links.home' | platformTranslate)()"
      (click)="handleHomeClick()" />

    @let apps = applications();
    @if (apps.length) {
      <div
        class="apps-list"
        data-testid="apps-menu--list">
        <p class="apps-menu__subtitle">{{ ('menus.applications.title' | platformTranslate)() }}</p>
        <div class="apps-menu__applications">
          @for (app of apps; track $index) {
            <button
              [attr.data-testid]="`apps-menu--${slugify(app.name)}`"
              class="apps-menu__item"
              [attr.data-name]="app.name"
              [evcTooltipHover]="app.name"
              (click)="handleAppClick(app)">
              <div class="apps-menu__app-badge">
                @if (isComputedWebApp(app)) {
                  <div
                    [innerHTML]="app.iconHtml"
                    class="icon"></div>
                } @else {
                  <evc-icon
                    size="xl"
                    [imgUrl]="getAppImgPath(app)"></evc-icon>
                }
              </div>
              <span class="apps-menu__app-name">{{ app.name }}</span>
            </button>
          }
        </div>
      </div>
    }
    <evc-button
      data-testid="apps-menu--marketplace"
      class="apps-menu__more-apps-btn button_full-width"
      type="primary"
      size="large"
      icon="add"
      [text]="('menus.applications.links.marketplace' | platformTranslate)()"
      (click)="handleMarketplaceClick()" />
  </div>
</evc-menu>
